import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ParticlesBackground from '../components/ParticlesBackground';
// import logo from '../logo.svg'; // Removed in favor of public asset

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      const from = location.state?.from?.pathname || '/admin';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    if (!email || !password) {
      setError('Please enter both email and password');
      setLoading(false);
      return;
    }

    try {
      const result = await login(email, password);

      if (result.success) {
        const from = location.state?.from?.pathname || '/admin';
        navigate(from, { replace: true });
      } else {
        setError(result.message || 'Login failed. Please check your credentials.');
      }
    } catch (err) {
      setError('An error occurred during login. Please try again.');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0118] relative flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Particle wrapper */}
      <div className="absolute inset-0 z-0">
        <ParticlesBackground />
      </div>

      <div className="max-w-md w-full space-y-8 relative z-10">


        {/* Login Form */}
        <div className="bg-white/5 backdrop-blur-lg border border-white/10 shadow-xl rounded-lg p-8">
          {/* Logo and Header */}
          <div className="text-center mb-8">
            <img src="/assets/images/logo.svg" alt="Impera Logo" className="h-16 mx-auto mb-4" />
            <p className="mt-2 text-sm text-gray-400">
              Sign in to manage your content
            </p>
          </div>

          <form className="space-y-6" onSubmit={handleSubmit}>
            {error && (
              <div className="bg-red-500/10 border border-red-500/50 text-red-200 px-4 py-3 rounded-md text-sm">
                {error}
              </div>
            )}

            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">
                Email Address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="appearance-none block w-full px-3 py-2 border border-gray-600 bg-gray-800/50 text-white placeholder-gray-400 rounded-md focus:outline-none focus:ring-purple-500 focus:border-purple-500 sm:text-sm transition duration-300"
                placeholder="admin@impera.com"
              />
            </div>

            <div>
              <label htmlFor="password" className="block text-sm font-medium text-gray-300 mb-2">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="appearance-none block w-full px-3 py-2 border border-gray-600 bg-gray-800/50 text-white placeholder-gray-400 rounded-md focus:outline-none focus:ring-purple-500 focus:border-purple-500 sm:text-sm transition duration-300"
                placeholder="Enter your password"
              />
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="w-full home-two-btn-bg h4_contact_bg border-transparent group relative flex justify-center py-3.5 px-4 text-sm font-medium text-white focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed transition duration-300"
              >
                {loading ? (
                  <span className="flex items-center relative z-10">
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Signing in...
                  </span>
                ) : (
                  <span className="relative z-10 group-hover:text-blue-seo transition-colors duration-300">Sign In</span>
                )}
              </button>
            </div>
          </form>


          {/* Footer */}
          <div className="text-center text-xs text-gray-500 mt-8">
            <Link to="/" className="hover:text-gray-300 transition-colors">
              Back to Home
            </Link>
            <p className="mt-2">© 2024 Impera. All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

